import { render, staticRenderFns } from "./ImgButtonList.vue?vue&type=template&id=0240d240"
import script from "./ImgButtonList.vue?vue&type=script&lang=js"
export * from "./ImgButtonList.vue?vue&type=script&lang=js"
import style0 from "./ImgButtonList.vue?vue&type=style&index=0&id=0240d240&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports